import React, { FC } from 'react'
import { graphql, useFragment } from 'react-relay'

import { Column, EventCard, Grid, Stack, useBreakpoint } from '@components'

import { HomeScreenEventsList_query$key } from './__generated__/HomeScreenEventsList_query.graphql'

import { INITIAL_COUNTS } from './HomeScreen'

export const HomeScreenEventsList: FC<{
  query: HomeScreenEventsList_query$key
}> = ({ query }) => {
  const data = useFragment(
    graphql`
      fragment HomeScreenEventsList_query on Query {
        upcomingEvents: eventsByTimeSelection(
          first: 4
          timeSelection: UPCOMING
        ) {
          edges {
            node {
              id
              ...EventCard_event
            }
          }
        }
        pastEvents: eventsByTimeSelection(first: 4, timeSelection: PAST) {
          edges {
            node {
              id
              ...EventCard_event
            }
          }
        }
      }
    `,
    query
  )

  // normally we can use cursors for React keys, but we are concatenating two different connections.
  // cursors are only guaranteed to be unique within one connection.
  const events = [
    ...(data.upcomingEvents?.edges ?? []),
    ...(data.pastEvents?.edges ?? []),
  ]

  const breakpoint = useBreakpoint()

  if (breakpoint === 0) {
    return (
      <Stack gap={4}>
        {events.slice(0, 4).map((edge) => (
          <EventCard
            key={edge.node.id}
            event={edge.node}
            showOrganizer
            showPresentationsOrAttendees
          />
        ))}
      </Stack>
    )
  }

  return (
    <Stack gap={4}>
      <Stack>
        <Grid gap={4}>
          {events.slice(0, INITIAL_COUNTS[breakpoint]).map((edge) => {
            return (
              <Column key={edge.node.id}>
                <EventCard
                  event={edge.node}
                  expand
                  showOrganizer
                  showPresentationsOrAttendees
                />
              </Column>
            )
          })}

          {Array.from({
            length: INITIAL_COUNTS[breakpoint] - (events.length || 0),
          }).map((_, index) => (
            <Column key={index} />
          ))}
        </Grid>
      </Stack>
    </Stack>
  )
}
